import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { GrantProgramCandidateRule } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'
import { SelectOption } from '@percent/lemonade'

export function useCandidateRuleOption(value: GrantProgramCandidateRule | undefined): {
  selectedOption: SelectOption
  options: SelectOption[]
} {
  const { t } = useTranslation()

  const resolvedValue = value ?? GrantProgramCandidateRule.UNIQUE_PER_ORG

  return useMemo(() => {
    const options: SelectOption[] = [
      {
        label: t('grants.program.modal.candidateRule.uniquePerOrg'),
        value: GrantProgramCandidateRule.UNIQUE_PER_ORG
      },
      {
        label: t('grants.program.modal.candidateRule.uniquePerNomination'),
        value: GrantProgramCandidateRule.UNIQUE_PER_NOMINATION
      }
    ]

    const selectedOption = options.find(o => o.value === resolvedValue) ?? options[0]

    return { selectedOption, options }
  }, [resolvedValue, t])
}
